import PropTypes from 'prop-types';
import {Grid} from '@mui/material';
import {useFormContext} from 'react-hook-form';
import {RHFTextField} from './RHFTextField';

export const RHFMultilingualField = ({name, md = 6}) => {
  const {control} = useFormContext();
  return (
    <Grid container spacing={2} alignItems='center'>
      {/* Commented on Client Request */}
      {/* <Grid item md={6}>
        <RHFTextField control={control} name={`${name}.en`} label={'English'} />
      </Grid> */}
      <Grid item md={md}>
        <RHFTextField control={control} name={`${name}.nl`} label={'Dutch'} />
      </Grid>
    </Grid>
  );
};

RHFMultilingualField.propTypes = {
  name: PropTypes.string.isRequired,
};
